document.addEventListener('DOMContentLoaded', function () {
    devtricker_initializeLikedFill();
});

async function devtricker_likeComment(event, commentId, button) {
    event.preventDefault();
    event.stopPropagation();

    try {
        let loggetUserId = devtricker_getTheLoggedUserId();

        if (!loggetUserId) {
            devtricker_openSocialLoginModal(event);
            button.dataset.liking = 'false';
            return;
        }

        if (button.dataset.liking === 'true') {
            return;
        }

        button.dataset.liking = 'true';

        let liked = devtricker_session_hasLikedComment(commentId);
        let likeAction = liked ? 'UNLIKE' : 'LIKE';

        console.log(JSON.stringify(liked));

        if (!liked) {
            devtricker_session_setLikedCommentStatus(commentId, true);
            devtricker_dom_comment_setLikeIconStyle(commentId, 'fill');
            devtricker_dom_comment_updateLikeCounter(commentId, 1);
        } else {
            devtricker_session_setLikedCommentStatus(commentId, false);
            devtricker_dom_comment_setLikeIconStyle(commentId, 'default');
            devtricker_dom_comment_updateLikeCounter(commentId, -1);
        }

        button.dataset.liking = 'false';

        await devtricker_comment_ajax_like(commentId, likeAction);

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        devtricker_showCommentErrorToast();
    }
}

async function devtricker_initializeLikedFill() {
    if (!devtricker_getTheLoggedUserId()) return;

    const pageGeneratedDate = devtricker_getPageGeneratedDate();
    const comments = document.querySelectorAll('#comments .comment');
    const commentIds = Array.from(comments).map(el => el.id.split('-')[2]).filter(id => id !== null);
    const knownCommentIds = new Set(devtricker_session_getAllKnownCommentIds());
    const unknownCommentIds = commentIds.filter(id => !knownCommentIds.has(id));

    if (unknownCommentIds.length > 0) {
        const commentRequestResult = await devtricker_ajax_checkIfLikedComments(unknownCommentIds);
        Object.entries(commentRequestResult).forEach(([commentId, data]) => {
            devtricker_session_setLikedCommentStatus(commentId, data.liked, data.liked_at);
        });
    }

    comments.forEach(comment => {
        const commentId = comment.id.split('-')[2];
        const hasLiked = devtricker_session_hasLikedComment(commentId);

        if (hasLiked) {
            devtricker_dom_comment_setLikeIconStyle(commentId, 'fill');
            const likedDate = devtricker_session_getLikedCommentDate(commentId);
            if (likedDate && likedDate > pageGeneratedDate) {
                devtricker_dom_comment_updateLikeCounter(commentId, 1);
            }
        }
    });
}